import { FC } from 'react';

export const PartnerInventoryListing: FC = () => {
  return <section>Inventory Listing</section>;
};
